import { defineComponent, h } from 'vue';
import { Modal, modalProps, ModalProps } from '@/ui/components/Modal';
import { button } from '@/ui/components';
import { ButtonProps } from '@/ui/components/Button';
import { ScimErrorLog } from '@/entities/sso-configuration';
import { CreatedAt } from '@/ui/components/sso/common/CreatedAt';
import { LogType } from '@/ui/components/sso/common/LogType';
import { Content } from '@/ui/components/sso/common/Content';
import { t } from '@/ui/i18n/i18n';

interface ErrorLogsModalProps extends ModalProps {
  closeText: string;
  width?: string;
  closeButtonProps: ButtonProps;
  logs: ScimErrorLog[];
}

export const ErrorLogsModal = defineComponent<ErrorLogsModalProps>({
  name: 'ErrorLogsModal',
  props: [...modalProps, 'logs', 'width', 'closeText', 'closeButtonProps'],
  setup(props, ctx) {
    return function render() {
      return h(Modal, {
        props: { ...props, hideClose: false, width: props.width ?? '500px' },
        on: {
          close: () => {
            ctx.emit('close');
          },
        },
      }, [
        h('h1', { class: 'sso-scim-role-information-modal__title' }, [t('sso.scim.error-logs-modal.title')]),
        h('div', { class: 'sso-scim-error-logs__log-list' }, [
          props.logs?.map((log: ScimErrorLog) => {
            return [
              h('div', { class: 'sso-scim-error-logs__log' }, [
                h(CreatedAt, { props: { log } }),
                h('div', { class: 'sso-scim-error-logs__log-type' }, [
                  h(LogType, { props: { log } }),
                  h(Content, { props: { log } }),
                ]),
              ]),
            ];
          }),
        ]),
        h('template', { slot: 'actions' }, [
          button(props.closeText, () => ctx.emit('accepted'), undefined, props.closeButtonProps),
        ]),
      ]);
    };
  },
});
